<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import _ from "lodash";
import { BaseAtom, getSignonManager, } from "components/cards/atoms";
import { ButtonParticle, TextParticle, } from "components/cards/particles/YinzCam";
import ImageParticle from "components/cards/particles/YinzCam/Core/Image/ImageParticle.svelte";
import { Toggle } from "framework7-svelte";
import RichTextParticle from "components/cards/particles/YinzCam/Core/RichText/RichTextParticle.svelte";
import { t } from "js/i18n";
import { eraseCookie } from "js/cookies";
import { resolveUrl } from "js/url";
import { getProfileFields } from "js/profile-fields";
import { COUNTRIES } from "components/cards/utilities/countries";
export let container = undefined;
export let outerBoxPadding = undefined;
export let outerBoxBackgroundColor = undefined;
export let outerBoxBorderRadius = undefined;
export let titleRowPadding = undefined;
export let titleText = undefined;
export let innerBoxPadding = undefined;
export let innerBoxBackgroundColor = undefined;
export let innerBoxBorderRadius = undefined;
export let innerBoxDividerColor = undefined;
export let leftSideWidth = undefined;
export let leftSideActiveButtonTemplate = undefined;
export let leftSideInactiveButtonTemplate = undefined;
export let leftRightGap = undefined;
export let formBlockGap = undefined;
export let profileImageTemplate = undefined;
export let formBlockTitleTextTemplate = undefined;
export let formFieldTitleTextTemplate = undefined;
export let formFieldDescriptionTextTemplate = undefined;
export let formFieldValueTextTemplate = undefined;
export let formBlockTitlePadding = undefined;
export let formTitleGap = undefined;
export let formGridRowGap = undefined;
export let defaultUserName = "PROFILE_DETAILS_DEFAULT_USER_NAME_NOT_CONFIGURED";
export let defaultAvatarUrl = "PROFILE_DETAILS_DEFAULT_AVATAR_URL_NOT_CONFIGURED";
export let loyaltyBalanceLabel = "PROFILE_DETAILS_LOYALTY_BALANCE_LABEL_NOT_CONFIGURED";
export let loyaltyBalanceCurrency = "PROFILE_DETAILS_LOYALTY_BALANCE_CURRENCY_NOT_CONFIGURED";
export let changeEmailUrl = "PROFILE_DETAILS_CHANGE_EMAIL_URL_NOT_CONFIGURED";
export let titlePrefixes = [];
export let sections = [];
export let supporterLevels = [];
export let defaultSupporterLevel = "PROFILE_DETAILS_DEFAULT_SUPPORTER_LEVEL_NOT_CONFIGURED";
export let marketingSections = [];
const fields = getProfileFields();
const VALID_SECTION_SLUGS = new Set(["my-profile", "settings"]);
$: validSections = sections.filter((section) => VALID_SECTION_SLUGS.has(section.slug));
$: invalidSections = sections.filter((section) => !VALID_SECTION_SLUGS.has(section.slug));
let selectedSection = "";
$: if (validSections.length > 0 && !validSections.some((s) => s.slug === selectedSection)) {
    selectedSection = validSections[0].slug;
}
let atomWidthPx;
function isNotConfigured(value) {
    return !value || value.includes("_NOT_CONFIGURED");
}
function configWarning(label) {
    return `${label} is not configured.`;
}
function formatLoyaltyBalance(rawBalance) {
    const balance = parseFloat(rawBalance || "");
    if (isNaN(balance))
        return "";
    if (!isNotConfigured(loyaltyBalanceCurrency)) {
        try {
            return new Intl.NumberFormat(CONFIG.defaultDateTimeLocale || undefined, {
                style: "currency",
                currency: loyaltyBalanceCurrency,
            }).format(balance);
        }
        catch (_a) {
            // Fall through to plain formatting if Intl rejects the currency code.
        }
    }
    return balance.toFixed(2);
}
const sso = getSignonManager();
const profileComp = sso.getDefaultProfileSegmentComponent();
const profile = profileComp.store;
$: loginStatus = sso.getStatusComponent().store;
$: isLoggedIn = $loginStatus.loggedIn;
let profileLoaded = false;
let profileFieldNotEditable = {};
$: profileData = (function ($profile) {
    if (profileLoaded) {
        return {};
    }
    if (!$profile || Object.keys($profile).length === 0) {
        return {};
    }
    profileLoaded = true;
    ["birthDate"].forEach((key) => (profileFieldNotEditable[key] = !!$profile[fields[key]]));
    return _.cloneDeep($profile || {});
})($profile);
$: profileEditable = profileLoaded;
function updateProfile(profileData) {
    sso.updateDefaultProfileSegment(profileData);
    profileComp.refresh();
}
const updateProfileThrottled = _.throttle(updateProfile, 2000, {
    leading: false,
    trailing: true,
});
function onTextChange(field, e) {
    profileData[fields[field]] = e.target.innerText;
    updateProfileThrottled(profileData);
}
function onSelectChange(field, e) {
    profileData[fields[field]] = e.target.value;
    updateProfile(profileData);
}
function onInputKeypress(e) {
    if (e.key === 'Enter') {
        e.target.blur();
        e.preventDefault();
    }
}
function onInputChange(field, e) {
    profileData[fields[field]] = e.target.value;
    updateProfile(profileData);
}
function changeProfileLocalBySsoField(ssoField, value) {
    if (!ssoField || profileData[ssoField] === value) {
        return false;
    }
    profileData[ssoField] = value;
    return true;
}
function onMarketingToggleChange(item, val) {
    var _a, _b;
    if (!item.ssoField) {
        return;
    }
    const strVal = val ? "true" : "false";
    if (!changeProfileLocalBySsoField(item.ssoField, strVal)) {
        return;
    }
    (_a = item.childSsoFields) === null || _a === void 0 ? void 0 : _a.forEach((field) => changeProfileLocalBySsoField(field, strVal));
    for (const section of marketingSections) {
        for (const sibling of section.items || []) {
            if (sibling.ssoField && ((_b = sibling.childSsoFields) === null || _b === void 0 ? void 0 : _b.length)) {
                const anyOn = sibling.childSsoFields.some((field) => field && profileData[field] === "true");
                changeProfileLocalBySsoField(sibling.ssoField, anyOn ? "true" : "false");
            }
        }
    }
    updateProfileThrottled(profileData);
}
function mapSupporterLevelNames(_profile) {
    const sln = (_profile[fields.supporterSchemeLevelNames] || "").toLowerCase();
    const match = supporterLevels.find((entry) => entry.pattern && sln.includes(entry.pattern.toLowerCase()));
    return (match === null || match === void 0 ? void 0 : match.label) || defaultSupporterLevel;
}
function handleLogout() {
    eraseCookie("_sa_sso_upid");
    sso.logout();
    resolveUrl("home").func();
}
$: {
    if (atomWidthPx <= 950 && atomWidthPx > 600) {
        formFieldValueTextTemplate = Object.assign({}, _.merge({}, formFieldValueTextTemplate, {
            container: { width: "30rem" },
        }));
    }
}
</script>

<BaseAtom
  _isotope="ProfileDetailsAtom"
  _cssVariablePrefix="profile-details"
  {...container}
  bind:_clientWidthPx={atomWidthPx}
  {outerBoxPadding}
  {outerBoxBackgroundColor}
  {outerBoxBorderRadius}
  {titleRowPadding}
  {leftSideWidth}
  {leftRightGap}
  {innerBoxPadding}
  {innerBoxBackgroundColor}
  {innerBoxBorderRadius}
  {innerBoxDividerColor}
  {formBlockGap}
  {formBlockTitlePadding}
  {formGridRowGap}
  {formTitleGap}
  formValueContainerWidth={formFieldValueTextTemplate?.container?.width || ""}
>
  <div class="outer-box" class:mobile-layout={atomWidthPx <= 950}>
    <div class="title-row">
      <TextParticle _block={true} {...titleText} />
    </div>
    <div class="inner-box">
      <div class="left-side">
        {#if sections.length === 0}
          <div class="config-warning">{configWarning("ProfileDetails sections")}</div>
        {:else if validSections.length === 0}
          <div class="config-warning">ProfileDetails sections contain no valid slugs. Valid slugs are my-profile, settings.</div>
        {:else}
          {#each validSections as section (section.slug)}
            <div id={`${section?.slug}-button`} class={`profile-button ${section?.slug}-button`}>
              <ButtonParticle
                on:click={() => (selectedSection = section.slug)}
                {..._.merge(
                  {},
                  selectedSection === section.slug
                    ? leftSideActiveButtonTemplate
                    : leftSideInactiveButtonTemplate,
                  { text: { text: $t(section.title) } },
                )}
              />
            </div>
          {/each}
          {#if invalidSections.length > 0}
            <div class="config-warning">
              Invalid ProfileDetails section slugs: {invalidSections.map((section) => section.slug || "(missing)").join(", ")}
            </div>
          {/if}
        {/if}
        <!-- <div class="left-side-spacer"></div> -->
        <div class="logout-button">
          <ButtonParticle
            on:click={handleLogout}
            {..._.merge({}, leftSideInactiveButtonTemplate, {
              text: { text: `${$t("Sign Out")}` },
            })}
          />
        </div>
      </div>
      <div class="right-side">
        <div
          class="form-section"
          class:form-section-active={selectedSection === "my-profile"}
        >
          <div class="form-block no-border-block">
            <div class="header-block">
              <div class="profile-image">
                <ImageParticle
                  _block={true}
                  {..._.merge({}, profileImageTemplate, {
                    source:
                      profileData?.[fields.imageUrl] || defaultAvatarUrl,
                  })}
                />
              </div>
              <div class="profile-header">
                <div class="profile-header-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formBlockTitleTextTemplate, {
                      text:
                        `${profileData?.[fields.firstName] || ""} ${profileData?.[fields.lastName] || ""}`.trim() ||
                        defaultUserName,
                    })}
                  />
                </div>
                <div class="form-field">
                  <div class="form-field-title">
                    <TextParticle
                      _block={true}
                      {..._.merge({}, formFieldTitleTextTemplate, {
                        text: mapSupporterLevelNames(profileData),
                      })}
                    />
                  </div>
                  {#if !isNaN(parseInt(profileData?.[fields.supporterTicketingMemberId]))}
                    <div class="form-field-description">
                      <RichTextParticle
                        _block={true}
                        {..._.merge({}, formFieldDescriptionTextTemplate, {
                          html:
                            `Supporter Number: ${profileData?.[fields.supporterTicketingMemberId]}`,
                        })}
                      />
                    </div>
                  {/if}
                  {#if !isNaN(parseFloat(profileData?.[fields.supporterAccountBalance]))}
                    <div class="form-field-description">
                      <RichTextParticle
                        _block={true}
                        {..._.merge({}, formFieldDescriptionTextTemplate, {
                          html:
                            isNotConfigured(loyaltyBalanceLabel) || isNotConfigured(loyaltyBalanceCurrency)
                              ? configWarning("ProfileDetails loyaltyBalanceLabel / loyaltyBalanceCurrency")
                              : `${loyaltyBalanceLabel}: ${formatLoyaltyBalance(profileData?.[fields.supporterAccountBalance])}`,
                        })}
                      />
                    </div>
                  {/if}
                </div>
              </div>
            </div>
          </div>
          <div class="form-block">
            <div class="form-block-title">
              <TextParticle
                _block={true}
                {..._.merge({}, formBlockTitleTextTemplate, {
                  text: "Personal Information",
                })}
              />
            </div>
            <div class="field-grid">
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Title",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <div class="form-field-value">
                    {#if titlePrefixes.length === 0}
                      <div class="config-warning">{configWarning("ProfileDetails titlePrefixes")}</div>
                    {:else}
                      <select value={profileData?.[fields.title] || ""} on:input={(e) => onSelectChange("title", e)}>
                        {#each titlePrefixes as prefix (prefix)}
                          <option selected={profileData?.[fields.title] === prefix} value={prefix}>{prefix}</option>
                        {/each}
                      </select>
                    {/if}
                  </div>
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Forename",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["firstName"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.firstName] || "",
                    })}
                    on:input={(e) => onTextChange("firstName", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Middle Names (or Initials)",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["middleName"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.middleName] || "",
                    })}
                    on:input={(e) => onTextChange("middleName", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Surname",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["lastName"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.lastName] || "",
                    })}
                    on:input={(e) => onTextChange("lastName", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Date of Birth",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <input
                    type="date"
                    class="date-of-birth-style"
                    value={profileData?.[fields.birthDate] || ""}
                    on:input={(e) => onInputChange("birthDate", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                    disabled={!(
                      profileEditable && !profileFieldNotEditable["birthDate"]
                    )}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Gender",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <select
                    value={profileData?.[fields.gender] || ""}
                    on:input={(e) => onSelectChange("gender", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                    disabled={!(
                      profileEditable && !profileFieldNotEditable["gender"]
                    )}
                    class="date-of-birth-style"
                  >
                    <option
                      selected={profileData?.[fields.gender] === "Prefer not to Say"}
                      value="Prefer not to Say">Prefer not to Say</option
                    >
                    <option
                      selected={profileData?.[fields.gender] === "Male"}
                      value="Male">Male</option
                    >
                    <option
                      selected={profileData?.[fields.gender] === "Female"}
                      value="Female">Female</option
                    >
                  </select>
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Email",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={false}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.email] || "",
                    })}
                  />
                </div>
                {#if isNotConfigured(changeEmailUrl)}
                  <div class="config-warning">{configWarning("ProfileDetails changeEmailUrl")}</div>
                {:else if changeEmailUrl}
                  <div class="form-field-link">
                    <a class="external" href={resolveUrl(changeEmailUrl).href}>{$t("Change email address")}</a>
                  </div>
                {/if}
              </div>
            </div>
          </div>
          <div class="form-block field-grid-block">
            <div class="form-block-title">
              <TextParticle
                _block={true}
                {..._.merge({}, formBlockTitleTextTemplate, {
                  text: "Contact Information",
                })}
              />
            </div>
            <div class="field-grid">
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Address",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["addressStreet1"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.addressStreet1] || "",
                    })}
                    on:input={(e) => onTextChange("addressStreet1", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["addressStreet2"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.addressStreet2] || "",
                    })}
                    on:input={(e) => onTextChange("addressStreet2", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Town/City",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["addressCity"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.addressCity] || "",
                    })}
                    on:input={(e) => onTextChange("addressCity", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "County",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["addressRegion"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.addressRegion] || "",
                    })}
                    on:input={(e) => onTextChange("addressRegion", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Postcode",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["addressPostalCode"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.addressPostalCode] || "",
                    })}
                    on:input={(e) => onTextChange("addressPostalCode", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Country",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <select
                    value={profileData?.[fields.addressCountry] || ""}
                    on:input={(e) => onSelectChange("addressCountry", e)}
                    disabled={!(profileEditable && !profileFieldNotEditable["addressCountry"])}
                  >
                    {#each COUNTRIES as country (country.code)}
                      <option selected={profileData?.[fields.addressCountry] === country.code} value={country.code}>{country.label}</option>
                    {/each}
                  </select>
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Mobile",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["phoneMobile"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.phoneMobile] || "",
                    })}
                    on:input={(e) => onTextChange("phoneMobile", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
              <div class="form-field">
                <div class="form-field-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formFieldTitleTextTemplate, {
                      text: "Landline",
                    })}
                  />
                </div>
                <div class="form-field-value">
                  <TextParticle
                    _block={true}
                    _editable={profileEditable &&
                      !profileFieldNotEditable["phoneLandline"]}
                    {..._.merge({}, formFieldValueTextTemplate, {
                      text: profileData?.[fields.phoneLandline] || "",
                    })}
                    on:input={(e) => onTextChange("phoneLandline", e)}
                    on:keydown={(e) => onInputKeypress(e)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="form-section"
          class:form-section-active={selectedSection === "settings"}
        >
          <div class="form-block no-border-block">
            <div class="header-block">
              <div class="profile-image">
                <ImageParticle
                  _block={true}
                  {..._.merge({}, profileImageTemplate, {
                    source:
                      profileData?.[fields.imageUrl] || defaultAvatarUrl,
                  })}
                />
              </div>
              <div class="profile-header">
                <div class="profile-header-title">
                  <TextParticle
                    _block={true}
                    {..._.merge({}, formBlockTitleTextTemplate, {
                      text:
                        `${profileData?.[fields.firstName] || ""} ${profileData?.[fields.lastName] || ""}`.trim() ||
                        defaultUserName,
                    })}
                  />
                </div>
                <div class="form-field">
                  <div class="form-field-title">
                    <TextParticle
                      _block={true}
                      {..._.merge({}, formFieldTitleTextTemplate, {
                        text: mapSupporterLevelNames(profileData),
                      })}
                    />
                  </div>
                  {#if !isNaN(parseInt(profileData?.[fields.supporterTicketingMemberId]))}
                  <div class="form-field-description">
                    <RichTextParticle
                      _block={true}
                      {..._.merge({}, formFieldDescriptionTextTemplate, {
                        html: `Supporter Number: ${profileData?.[fields.supporterTicketingMemberId]}`,
                      })}
                    />
                  </div>
                  {/if}
                  {#if !isNaN(parseFloat(profileData?.[fields.supporterAccountBalance]))}
                  <div class="form-field-description">
                    <RichTextParticle
                      _block={true}
                      {..._.merge({}, formFieldDescriptionTextTemplate, {
                        html:
                          isNotConfigured(loyaltyBalanceLabel) || isNotConfigured(loyaltyBalanceCurrency)
                            ? configWarning("ProfileDetails loyaltyBalanceLabel / loyaltyBalanceCurrency")
                            : `${loyaltyBalanceLabel}: ${formatLoyaltyBalance(profileData?.[fields.supporterAccountBalance])}`
                      })}
                    />
                  </div>
                  {/if}
                </div>
              </div>
            </div>
          </div>
          {#if marketingSections.length === 0}
            <div class="form-block">
              <div class="config-warning">{configWarning("ProfileDetails marketingSections")}</div>
            </div>
          {:else}
            {#each marketingSections as section, sectionIndex (sectionIndex)}
              <div class="form-block">
                <div class="form-block-title">
                  <TextParticle _block={true} {..._.merge({}, formBlockTitleTextTemplate, { text: section.title })} />
                </div>
                <div class="field-grid">
                  {#each section.items || [] as item (item.ssoField)}
                    {#if !item.ssoField || !item.title}
                      <div class="form-field full-width">
                        <div class="config-warning">{configWarning("ProfileDetails marketing item ssoField / title")}</div>
                      </div>
                    {:else}
                      <div class={item.fullWidth ? "form-field full-width" : "form-field"}>
                        <div class="form-field-title">
                          <TextParticle _block={true} {..._.merge({}, formFieldTitleTextTemplate, { text: item.title })} />
                        </div>
                        {#if item.description}
                          <div class="form-field-description">
                            <RichTextParticle _block={true} {..._.merge({}, formFieldDescriptionTextTemplate, { html: item.description })} />
                          </div>
                        {/if}
                        <div class="form-field-value">
                          <Toggle
                            checked={profileData?.[item.ssoField] === "true"}
                            onToggleChange={(val) => onMarketingToggleChange(item, val)}
                          />
                        </div>
                      </div>
                    {/if}
                  {/each}
                </div>
              </div>
            {/each}
          {/if}
        </div>
      </div>
    </div>
  </div>
</BaseAtom>

<style>
    .outer-box.mobile-layout .inner-box{
      display: flex;
      flex-direction: column;
    }
  .outer-box.mobile-layout .inner-box .left-side{
        flex-flow: row wrap;
        border: none;
      }
  .outer-box.mobile-layout .inner-box .right-side .form-section{
          /* display: flex; */
          justify-content: space-between;
        }
  .outer-box.mobile-layout .inner-box .right-side .form-block{
          width: 100%;
          align-items: center;
        }
  .outer-box.mobile-layout .inner-box .right-side .header-block{
          flex-direction: column;
          align-items: center;
        }
  .outer-box.mobile-layout .inner-box .right-side .form-block-title{
          width: 100%;
        }
  .outer-box.mobile-layout .inner-box .right-side .field-grid{
          display: flex;
          flex-direction: column;
          width: 100%;
        }
  .outer-box.mobile-layout .inner-box .right-side .form-field{
          width: 100%;
          gap: 1rem;
        }
  .outer-box.mobile-layout .inner-box .right-side .form-field-value{
          width: 100%;
          /* > :global(*) {
            width: 80%;
          } */
        }
  .outer-box {
    padding: var(--profile-details-outer-box-padding, unset);
    background-color: var(--profile-details-outer-box-background-color, unset);
    border-radius: var(--profile-details-outer-box-border-radius, unset);
    width: 100%;
  }

  .title-row {
    padding: var(--profile-details-title-row-padding, unset);
    display: flex;
    flex-flow: row nowrap;
    justify-content: start;
    width: 100%;
  }

  .inner-box {
    padding: var(--profile-details-inner-box-padding, unset);
    background-color: var(--profile-details-inner-box-background-color, unset);
    border-radius: var(--profile-details-inner-box-border-radius, unset);

    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: var(--profile-details-left-right-gap, unset);
    gap: var(--profile-details-left-right-gap, unset);
    width: 100%;
  }

  .left-side {
    border-right: 2px solid
      var(--profile-details-inner-box-divider-color, unset);
    display: flex;
    flex-flow: column nowrap;
    align-items: start;
    justify-content: start;
  }

  .left-side > .left-side-spacer {
    flex: 1 0 auto;
  }

  .right-side {
    display: block;

    --f7-toggle-width: 3.25rem;
    --f7-toggle-height: 1.5rem;
    --f7-toggle-border-color: #e5e5e5;
    --f7-toggle-inactive-color: #989898;
    --f7-toggle-active-color: var(--theme-mode-accent-color, black);
  }

  .right-side
    :global(.toggle input[type="checkbox"]:checked + .toggle-icon:after) {
    background-color: var(--theme-mode-background-color);
  }

  .form-section {
    display: none;
    flex-flow: column nowrap;
    justify-content: start;
    align-items: start;
    gap: var(--profile-details-form-block-gap, unset);
  }

  .form-section.form-section-active {
    display: flex;
  }

  .form-block {
    display: flex;
    flex-flow: column nowrap;
    justify-content: start;
    align-items: start;
    gap: var(--profile-details-form-title-gap, unset);
    width: 100%;
    border-top: 2px solid var(--profile-details-inner-box-divider-color, unset);
  }

  .no-border-block {
    border: none !important;
  }

  .header-block {
    display: flex;
    flex-flow: row nowrap;
    justify-content: start;
    align-items: start;
    gap: 1.5rem;
    width: 100%;
  }

  .field-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    grid-row-gap: var(--profile-details-form-grid-row-gap, unset);
    row-gap: var(--profile-details-form-grid-row-gap, unset);
    grid-column-gap: var(--profile-details-form-grid-row-gap, unset);
    -webkit-column-gap: var(--profile-details-form-grid-row-gap, unset);
       -moz-column-gap: var(--profile-details-form-grid-row-gap, unset);
            column-gap: var(--profile-details-form-grid-row-gap, unset);
  }

  .profile-header {
    display: flex;
    flex-flow: column nowrap;
    justify-content: start;
    align-items: start;
    gap: 1.12rem;
  }

  .form-block-title {
    padding: var(--profile-details-form-block-title-padding, unset);
    /* border-top: 2px solid var(--profile-details-inner-box-divider-color, unset); */
  }

  .form-field {
    display: flex;
    flex-flow: column nowrap;
    justify-content: start;
    align-items: start;
    gap: 0.5rem;
  }


  .form-field.full-width {
    grid-column: span 2;
  }

  .config-warning {
    color: var(--theme-mode-accent-color, #dd1f30);
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.2;
  }

  select,
  input {
    border-bottom: 1px solid #eaeaea;
    width: var(--profile-details-form-value-container-width, unset);
  }
  .date-of-birth-style {
    color: #636466;
    font-size: 1.125rem;
    font-weight: 700;
  }</style>
